/**
 * src/shell/hooks/useInventory.ts
 *
 * Reactive hook for observing and mutating domain inventory state.
 */

import { useState, useEffect, useCallback } from 'react';
import { inventoryService } from '../../domain/inventory/InventoryService';
import { ArtworkProduct, DomainProduct } from '../../domain/inventory/types/product-types';

export function useInventory(role = 'guest') {
  const [artworks, setArtworks] = useState<ArtworkProduct[]>([]);
  const [loading, setLoading] = useState(true);

  const refresh = useCallback(async () => {
    setLoading(true);
    try {
      const items = await inventoryService.listArtworks(role);
      setArtworks(items);
    } catch (err) {
      console.error('[useInventory] Error listing artworks:', err);
    } finally {
      setLoading(false);
    }
  }, [role]);

  useEffect(() => {
    refresh();
  }, [refresh]);

  return {
    artworks,
    loading,
    refresh,
    inventoryService,
  };
}
